import { DatePicker } from "rsuite";
import "./datepicker.scss";
import { UiAlert } from "../alert";
import { useEffect, useState } from "react";

interface UiDatepickerProps {
  label?: string;
  className?: string;
  name?: string;
  format?: string;
  placeholder?: string;
  defaultValue?: null | Date;
  errors?: string[];
  groupClassname?: string;
  onChange?: (date: Date | null) => void;
  onOk?: (date: Date, event: React.SyntheticEvent) => void;
  onClean?: (event: React.MouseEvent) => void;
  shouldDisableDate?: (date: Date) => boolean;
}

export function UiDatepicker({
  label,
  className,
  name,
  format,
  placeholder,
  defaultValue,
  groupClassname,
  errors,
  onChange,
  onOk,
  onClean,
  shouldDisableDate,
}: UiDatepickerProps) {
  const [value, setValue] = useState<Date | null>(defaultValue || null);

  useEffect(() => {
    setValue(defaultValue || null);
  }, [defaultValue]);

  const handleDateChange = (date: Date | null) => {
    setValue(date);
    // Appeler automatiquement onChange quand la date change
    if (onChange) {
      onChange(date);
    }
  };

  return (
    <div className={groupClassname || ""}>
      {label && <label className="ui-form-label">{label}</label>}
      <DatePicker
        defaultValue={defaultValue}
        onChange={handleDateChange}
        onClean={(event) => {
          setValue(null);
          if (onChange) {
            onChange(null);
          }
          if (onClean) {
            onClean(event);
          }
        }}
        value={value}
        placeholder={placeholder}
        format={format}
        name={name}
        className={className}
        shouldDisableDate={shouldDisableDate}
        size="lg"
        style={{ zIndex: 95 }}
        oneTap={true}
        showMeridian={false}
        locale={{
          sunday: "Dim",
          monday: "Lun",
          tuesday: "Mar",
          wednesday: "Mer",
          thursday: "Jeu",
          friday: "Ven",
          saturday: "Sam",
          ok: "OK",
          today: "Aujourd'hui",
          yesterday: "hier",
          hours: "Heures",
          minutes: "Minutes",
          seconds: "Secondes",
        }}
      />
      {errors && errors.length > 0 && (
        <UiAlert>
          {errors?.map((e) => (
            <p key={e}>{e}</p>
          ))}
        </UiAlert>
      )}
    </div>
  );
}
